import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 5L20 5M0 10H20M0 15H20" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

export default Icon;
